export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Actualizar campos"])},
          "click_to_upload": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Haga clic para subir"])},
          "drag_and_drop_file": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" o arrastre y suelte un archivo aquí"])},
          "upload_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Actualizar"])},
          "close_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cerrar"])}
        }
      },
      "en": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Update Fields"])},
          "click_to_upload": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Click to upload"])},
          "drag_and_drop_file": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" or drag and drop a file here"])},
          "upload_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Update"])},
          "close_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Close"])}
        }
      }
    }
  })
}